module.exports = __webpack_public_path__ + "media/icons/naped-4x4-grey@2x-bfc3a135.png";